/* eslint-disable quote-props */
import isNil from 'lodash/isNil';

import { getItem, setItem } from 'utils/storage/sessionStorage';

import type { SOVGeneralAuthInfo, SOVGeneralEndpointData } from 'modules/insights/sov/types/consumer-insights';

type ConfigOptions = {
  config: {
    headers: {
      Authorization: string
    },
    data?: SOVGeneralEndpointData
  },
  options: {
    suppressAuth: boolean
  }
};

export const LOCAL_STORAGE_KEY = 'ci-sov-report';
export const CONSUMER_INSIGHTS = 'consumer-insights';
export const ERROR_PAGE_URL = '/consumer-insights/sov/error';

export const VIDEO_TUTORIAL_GALLERY_MODAL_OBJECT = {
  type: 'youtube',
  assetUrl: 'https://i.ytimg.com/vi/XKx7ug85584/mqdefault.jpg',
  embedUrl: 'https://www.youtube-nocookie.com/embed/XKx7ug85584',
  url: 'https://www.youtube.com/watch?v=XKx7ug85584'
};

export const getAuthInfo = (reportId?: number | null): Partial<SOVGeneralAuthInfo> => {
  if (reportId) {
    const authInfo = getItem(`${LOCAL_STORAGE_KEY}-${String(reportId)}`);

    if (isNil(authInfo)) {
      return {};
    }

    return JSON.parse(authInfo);
  }

  return {};
};

export const setAuthInfo = (reportId: number | undefined | null, authInfo: Partial<SOVGeneralAuthInfo>): void => {
  const authInfoString = JSON.stringify(authInfo);

  if (reportId) {
    setItem(`${LOCAL_STORAGE_KEY}-${String(reportId)}`, authInfoString);
  }
};

export const getConfigOptions = (authInfo: Partial<SOVGeneralAuthInfo>): ConfigOptions => ({
  config: {
    headers: {
      Authorization: authInfo.token || '',
      ...(authInfo.brandCode ? { 'brand-code': authInfo.brandCode } : null),
      ...(authInfo.supplierCode ? { 'supplier-code': authInfo.supplierCode } : null)
    }
  },

  options: {
    suppressAuth: true
  }
});

export const getEndpointConfig = (
  reportId?: number | null,
  data?: SOVGeneralEndpointData
): Partial<ConfigOptions> => {
  if (isNil(reportId)) {
    return {};
  }

  const authInfo = getAuthInfo(reportId);
  const configOptions = getConfigOptions(authInfo);

  return {
    options: configOptions.options,
    config: {
      ...configOptions.config,
      data
    }
  };
};
